import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, Row, Col, message, Select } from "antd";
import { handleUpdateAutoBusinessUnit } from "../../../api/autorequests";
import { handleFetchUnits } from "../../../api/units";
import { useEffect } from "react";

const { Option } = Select;

export default function UpdateBusiness({
  isVisible,
  setVisible,
  selected,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { data: units } = useQuery({
    queryKey: ["units"],
    queryFn: handleFetchUnits,
  });

  const { mutate, isPending } = useMutation({
    mutationFn: handleUpdateAutoBusinessUnit,
    onSuccess: () => {
      message.success("Update Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["requests"] });
      queryClient.invalidateQueries({ queryKey: ["autorequests"] });
      queryClient.invalidateQueries({ queryKey: ["unitRequests"] });
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const data = { ...values };
    await mutate({ _id: selected?._id, data });
    setVisible(false);
  };

  const unitOptions = units?.records?.map((model: any, index: number) => (
    <Option value={model?._id} key={index}>
      {model?.name}
    </Option>
  ));

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.setFieldsValue({
      businessUnit: selected?.requestedFor?.businessUnitRef,
    });
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Assign Business Unit"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateAutorequester"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="updateAutorequester"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="businessUnit"
              label="Business Unit"
              rules={[
                {
                  required: true,
                  message: "Please select business unit",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Business Unit"
              >
                {unitOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
